var _ellipse, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNonFavoris(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 11.25,
    cy: 11.25,
    rx: 11.25,
    ry: 11.25,
    fill: "#6B716A"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 10.4371L10 15.4371L16 7.9375",
    stroke: "white",
    strokeWidth: 1.18679,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNonFavoris);
export default __webpack_public_path__ + "static/media/non_favoris.243dac15c0fd4a1ddba5b3c28ec265fd.svg";
export { ForwardRef as ReactComponent };